import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react';

import {
  Row,
  Col,
  Input,
  Select,
  Radio,
  DatePicker,
} from 'antd';
import moment from 'moment-timezone';
import NumberFormat from 'react-number-format';

import {
  SpForm, SpError, SpTextMute, SpCaption,
  SpText,
} from 'components/DesignKit';

import SimpleReactValidator from 'simple-react-validator';

import {
  validators,
} from 'utils/validationMessages';

import { API_END_POINTS } from 'api';

import formatAmount from 'utils/formatAmount';

import { MESSAGES, COUNTRY_CODES, PHONE_LENGTH } from 'appconstants';

import KYCFileUpload from 'components/KycFileUpload';

const { Option } = Select;


type Props = {
  businessTypes: Array<Object>,
  businessCategories: Array<Object>,
  statesInCountry: Array<Object>,
  country: string,
  isIndia: boolean,
  selectedAccount: Object,
  selectedBusinessType: Function,
  // pageData: Object,
}

const BusinessDetails = (props: Props, ref) => {
  const {
    businessTypes,
    businessCategories,
    statesInCountry,
    country,
    isIndia,
    selectedAccount,
    selectedBusinessType,
    // pageData,
  } = props;

  const BUSINESS_VALUES = ['PRIVATE_LIMITED', 'PUBLIC_LIMITED', 'NONPROFIT_ORGANIZATION'];

  const [, forceUpdate] = useState();
  const [name, setName] = useState(null);
  const [businessType, setBusinessType] = useState(selectedAccount?.accountType === 'INDIVIDUAL' ? 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP' : undefined);
  const [businessCategory, setBusinessCategory] = useState();
  const [businessUrl, setBusinessUrl] = useState(null);
  const [businessPan, setBusinessPan] = useState(null);
  const [cin, setCin] = useState(null);
  const [gst, setGst] = useState(null);
  const [tan, setTan] = useState(null);

  const [employerIdNumber, setEmployerIdNumber] = useState(null);
  const [streetAddress, setStreetAddress] = useState(null);
  const [zipCode, setZipCode] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState();
  const [statementDescriptor, setStatementDescriptor] = useState('');
  const [registrationProofUrl, setRegistrationProofUrl] = useState('');
  const [panUrl, setPanUrl] = useState('');
  const [zipTag, setZipTag] = useState('');
  const [accountType, setAccountType] = useState('PAYMENT_GATEWAY');
  const [annualTurnOver, setAnnualTurnOver] = useState('');
  const [annualCardVolume, setAnnualCardVolume] = useState('');
  const [annualUpiVolume, setAnnualUpiVolume] = useState('');
  const [frontUrl, setFrontUrl] = useState('');
  const [insideUrl, setInsideUrl] = useState('');
  const [businessAddressUrl, setBusinessAddressUrl] = useState('');
  const [boardResolutionUrl, setBoardResolutionUrl] = useState('');
  const [gstProofUrl, setGstProofUrl] = useState('');
  const [eightyTwelveUrl, setEightyTwelveUrl] = useState(null);
  const [companyStartDate, setCompanyStartDate] = useState('2021-06-01');
  const [isTaxExemptOrganisation, setIsTaxExemptOrganisation] = useState('');
  const currencyType = selectedAccount && selectedAccount.currency;
  const gstRegex = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
  const tanRegex = /^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$/;
  const cinRegex = /^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/;
  const panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  const einRegex = /^([07][1-7]|1[0-6]|2[0-7]|[35][0-9]|[468][0-8]|9[0-589])-?\d{7}$/;
  const llpRegex = /[a-zA-Z0-9]{7}/;
  const postalCodeRegex = country === 'India' ? /^[1-9][0-9]{5}$/ : /^[0-9][0-9]{4}$/;
  const descriptorRegex = /[<>'"*]/;
  const businessNameRegex = /^[ ]*([a-zA-Z'-.]{1,}( [a-zA-z'-. ]{1,})?)$/;
  const ifNumber = /^[0-9]+$/;
  const [countryCode, setCountryCode] = useState('+1');
  const [phoneFormate, setPhoneFormate] = useState('');
  const [businessPhoneNumber, setBusinessPhoneNumber] = useState('');

  useEffect(() => {
    if ((selectedAccount && selectedAccount.country && selectedAccount.country.id) === 1) {
      setZipTag('Zip code');
    } else if ((selectedAccount && selectedAccount.country && selectedAccount.country.id) === 2) {
      setZipTag('Pin code');
    }
  }, []);

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      validUrl: {
        message: 'Business website must be valid',
        // eslint-disable-next-line max-len
        rule: val => (new RegExp('^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$').exec(val) !== null),
      },
      cin: {
        message: MESSAGES.BUSINESS_DETAILS.CIN,
        rule: val => cinRegex.test(val),
      },
      llp: {
        message: MESSAGES.BUSINESS_DETAILS.LLP,
        rule: val => llpRegex.test(val),
      },
      tan: {
        message: MESSAGES.BUSINESS_DETAILS.TAN,
        rule: val => tanRegex.test(val),
      },
      gst: {
        message: MESSAGES.BUSINESS_DETAILS.GST,
        rule: val => gstRegex.test(val),
      },
      pan: {
        message: MESSAGES.BUSINESS_DETAILS.PAN,
        rule: val => panRegex.test(val),
      },
      EIN: {
        message: MESSAGES.BUSINESS_DETAILS.EIN,
        rule: val => einRegex.test(val),
      },
      postalcode: {
        message: validators.address.pincode,
        rule: val => (postalCodeRegex.test(val)),
      },
      descriptor: {
        message: 'Statement Descriptor min 5 and max 22 characters',
        // eslint-disable-next-line max-len
        rule: val => val && val.length >= 5 && val.length <= 22 && !descriptorRegex.test(val) && Boolean(val.charAt(0).match(/[a-zA-Z]/)) && Boolean(val.charAt(val.length - 1).match(/[a-zA-Z]/)),
      },
      phoneLength: {
        message: MESSAGES.ADD_USER.PHONE,
        rule: val => val.length >= PHONE_LENGTH.MIN && val.length <= PHONE_LENGTH.MAX,
      },
      isNumberField: {
        message: 'Enter number',
        rule: (val) => (ifNumber.test(val)),
      },
      isBusinessValid: {
        message: 'Business Name should be at least 4 characters long',
        rule: (val) => (val.length >= 4),
      },
      validname: {
        message: 'Please enter a valid Business Name',
        // eslint-disable-next-line no-useless-escape
        rule: val => /^[A-Za-z0-9][A-Za-z0-9\s\-.,'$@_]*[A-Za-z0-9\s\-.,'$@_]$/.test(val),
      },
      legalNameValidation: {
        message: "Legal name must be alphanumeric and may include &, -, ., ', $, @, _, and spaces only.",
        rule: val => /^[A-Za-z0-9&,\s.\-'$@_]{1,50}$/.test(val),
      },
      validBusinessName: {
        message: 'Business Name cannot have special characters or numbers',
        rule: (val) => (businessNameRegex.test(val)),
      },
    },
  }));

  simpleValidator.current.purgeFields();

  const onCountryCodeChange = (value) => {
    if (value === '+1') {
      setPhoneFormate('(###) ###-####');
      setCountryCode(value);
    } else if (value === '+91') {
      setPhoneFormate('##### #####');
      setCountryCode(value);
    } else {
      setPhoneFormate('##########');
      setCountryCode(value);
    }
  };

  useEffect(() => {
    if (countryCode === '+1') {
      setPhoneFormate('(###) ###-####');
    } else if (countryCode === '+91') {
      setPhoneFormate('##### #####');
    }
  }, []);

  const onPhoneNumberChange = (e) => {
    const updatedPhone = e.currentTarget.value;
    setBusinessPhoneNumber(updatedPhone.replace(/[^0-9+]/g, ''));
  };

  useEffect(() => {
    if (accountType !== 'POS') {
      simpleValidator.current.purgeFields();
    }
  }, [accountType]);

  const updateGst = (e) => {
    if (e.currentTarget.value) {
      setGst(e.currentTarget.value.toUpperCase());
    } else if (!e.currentTarget.value) {
      setGst(null);
      simpleValidator.current.purgeFields();
    }
  };

  const updateTan = (e) => {
    if (e.currentTarget.value) {
      setTan(e.currentTarget.value.toUpperCase());
    } else if (!e.currentTarget.value) {
      setTan(null);
      simpleValidator.current.purgeFields();
    }
  };

  const bussinessTypeChange = (event) => {
    selectedBusinessType(event);
    setBusinessType(event);
    if (event === 'PROPRIETORSHIP') {
      simpleValidator.current.purgeFields();
    }
  };

  const onAccountChange = (e) => {
    setAccountType(e.target.value);
  };

  useImperativeHandle(ref, () => ({
    validate: () => {
      const formValid = simpleValidator.current.allValid();
      if (!formValid) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return false;
      }
      return true;
    },
    getValues: () => ({
      name,
      businessType,
      businessCategory,
      businessUrl,
      companyStartDate,
      businessPhoneNumber,
      countryCode,
      isTaxExemptOrganisation,
      employerIdNumber: employerIdNumber || null,
      streetAddress,
      zipCode,
      city,
      state,
      statementDescriptor,
      registrationProofUrl,
      panUrl,
      businessPan,
      cin,
      gst,
      tan,
      accountType,
      annualTurnOver: annualTurnOver ? annualTurnOver.replace(/[^\d]/g, '') : '',
      annualCardVolume: annualCardVolume ? annualCardVolume.replace(/[^\d]/g, '') : '',
      annualUpiVolume: annualUpiVolume ? annualUpiVolume.replace(/[^\d]/g, '') : '',
      frontUrl,
      insideUrl,
      isLLP: businessType !== 'PROPRIETORSHIP' && !BUSINESS_VALUES.includes(businessType),
      currentAddressProofUrl: businessAddressUrl,
      boardResolutionUrl,
      gstCertificateUrl: gstProofUrl,
      eightyGAndTwelveACertificate: eightyTwelveUrl,
    }),
  }));

  return (
    <>
      <Row type="flex" justify="space-between" className="mt-2 my-2 mb-3">
        <Col className="d-flex align-items-center">
          <SpText className="mr-4" fontSize="20px" fontWeight="600">Business Information</SpText>
        </Col>
      </Row>
      <SpForm>
        <Row type="flex" justify="start" align="middle">
          <Col span={8}>
            <span>Business Name</span>
          </Col>
          <Col span={16}>
            <Input
              value={name}
              placeholder="Legal Business Name"
              onBlur={() => setName(name && name.trim())}
              onChange={e => setName(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('Name', name, 'required|validname|legalNameValidation')}
            </SpError>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={8}>
            <span>Business Type</span>
          </Col>
          <Col span={16}>
            <Select
              placeholder="Select Business Type"
              className="w-100"
              value={businessType}
              onChange={bussinessTypeChange}
            >
              { selectedAccount?.accountType && selectedAccount?.accountType === 'BUSINESS'
                ? businessTypes.filter((item) => item?.value !== 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP').map(business => (
                  <Option
                    key={1}
                    value={business.value}
                    className="text-capitalize"
                  >
                    {business.display}
                  </Option>
                ))
                : businessTypes.map(business => (
                  <Option
                    key={1}
                    value={business.value}
                    className="text-capitalize"
                  >
                    {business.display}
                  </Option>
                )) }
            </Select>
            <SpError>
              {simpleValidator.current.message('Business Type', businessType, 'required')}
            </SpError>
          </Col>
        </Row>
        <Row type="flex" justify="start" align="middle">
          <Col span={8} align="left">
            <span>Business Category</span>
          </Col>
          <Col span={16}>
            <Select
              placeholder="Select Business Category"
              showSearch
              optionFilterProp="children"
              className="w-100"
              value={businessCategory}
              onChange={value => setBusinessCategory(value)}
            >
              {
                businessCategories.map(category => (
                  <Option
                    key={1}
                    value={category.id}
                    className="text-capitalize"
                  >
                    {category.name}
                  </Option>
                ))
              }
            </Select>
            <SpError>
              {simpleValidator.current.message('Business Category', businessCategory, 'required')}
            </SpError>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={8}>
            <span>Business Website</span>
          </Col>
          <Col span={16}>
            <Input
              placeholder="Legal Business URL"
              value={businessUrl}
              onBlur={() => setBusinessUrl(businessUrl && businessUrl.trim())}
              onChange={e => setBusinessUrl(e.currentTarget.value && e.currentTarget.value.toLowerCase())}
            />
            <SpError>
              {simpleValidator.current.message('Business Url', businessUrl, 'required|validUrl')}
            </SpError>
          </Col>
        </Row>

        {!isIndia && (
          <Row type="flex" justify="start" align="middle">
            <Col span={8}>
              <span>Company Start Date</span>
            </Col>
            <Col span={16}>
              <DatePicker
                allowClear={false}
                onChange={(date, dateString) => setCompanyStartDate(dateString)}
                disabledDate={current => current && current > moment().subtract(1, 'days')}
              />
              <SpError>
                {simpleValidator.current.message('Company Start Date', companyStartDate, 'required')}
              </SpError>
            </Col>
            <Col span={24} className="ml-4">
              <SpTextMute>
                Ensure it matches with provided EIN
              </SpTextMute>
            </Col>
          </Row>
        )}
        {
          isIndia ? (
            <>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>Business PAN</span>
                </Col>
                <Col span={16}>
                  <Input
                    placeholder="Business PAN"
                    value={businessPan}
                    onBlur={() => setBusinessPan(businessPan && businessPan.trim())}
                    onChange={e => setBusinessPan((e.currentTarget.value).toUpperCase())}
                  />
                  <SpError>
                    {simpleValidator.current.message('pan', businessPan, 'required|pan', { messages: { required: 'The PAN field is required.' } })}
                  </SpError>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                {
                  (businessType !== 'PROPRIETORSHIP') && (
                    <>
                      {
                        businessType === 'LIMITED_LIABILITY_PARTNERSHIP' ? (
                          <>
                            <Col span={8} align="left">
                              <span>
                                LLP ID
                              </span>
                            </Col>
                            <Col span={16}>
                              <Input
                                value={cin}
                                placeholder="LLP ID"
                                onBlur={() => setCin(cin && cin.trim())}
                                onChange={e => setCin((e.currentTarget.value).toUpperCase())}
                              />
                              <SpError>
                                {simpleValidator.current.message('CIN', cin, 'required|llp',
                                  { messages: { required: 'The LLP ID field is required' } })}
                              </SpError>
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col span={8} align="left">
                              <span>
                                Company Identification Number (CIN)
                              </span>
                            </Col>
                            <Col span={16}>
                              <Input
                                value={cin}
                                placeholder="Company Identification Number"
                                onBlur={() => setCin(cin && cin.trim())}
                                onChange={e => setCin((e.currentTarget.value).toUpperCase())}
                              />
                              {
                                businessType === 'NONPROFIT_ORGANIZATION' ? (
                                  <SpError>
                                    {simpleValidator.current.message('CIN', cin, 'cin')}
                                  </SpError>
                                ) : (
                                  <SpError>
                                    {simpleValidator.current.message('CIN', cin, 'required|cin',
                                      { messages: { required: 'The CIN field is required' } })}
                                  </SpError>
                                )
                              }
                            </Col>
                            {
                              businessType === 'NONPROFIT_ORGANIZATION' ? (
                                <Col>
                                  <SpCaption className="pl-2">(Optional)</SpCaption>
                                </Col>
                              ) : null
                            }
                          </>
                        )
                      }
                    </>
                  )
                }
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>GST Identification Number</span>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
                <Col span={16}>
                  <Input
                    placeholder="GST Identification Number"
                    value={gst}
                    onBlur={() => setGst(gst && gst.trim())}
                    onChange={updateGst}
                  />
                  <SpError>
                    {gst ? simpleValidator.current.message('gst', gst, 'gst') : ''}
                  </SpError>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>Tax deduction account number (TAN)</span>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
                <Col span={16}>
                  <Input
                    placeholder="TAN Number"
                    value={tan}
                    onBlur={() => setTan(tan && tan.trim())}
                    onChange={updateTan}
                  />
                  <SpError>
                    {tan ? simpleValidator.current.message('tan', tan, 'tan') : ''}
                  </SpError>
                </Col>
              </Row>
            </>
          ) : (
            <Row type="flex" justify="start" align="middle">
              <Col span={8}>
                <span>Employer Identification No.</span>
                {(businessType === 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP') || (businessType === 'LIMITED_LIABILITY_COMPANY')
                  ? (
                    <SpCaption className="pl-4">(Optional)</SpCaption>
                  ) : null}
              </Col>
              <Col span={16}>
                <Input
                  placeholder="EIN of the company"
                  value={employerIdNumber}
                  onBlur={() => setEmployerIdNumber(employerIdNumber && employerIdNumber.trim())}
                  onChange={e => setEmployerIdNumber(e.currentTarget.value)}
                />
                {(businessType !== 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP') && (businessType !== 'LIMITED_LIABILITY_COMPANY')
                  ? (
                    <SpError>
                      {simpleValidator.current.message('Employer Id Number', employerIdNumber, 'required|EIN')}
                    </SpError>
                  ) : (
                    <SpError>
                      {simpleValidator.current.message('Employer Id Number', employerIdNumber, 'EIN')}
                    </SpError>
                  )}
              </Col>
            </Row>
          )
        }

        {!isIndia && (
          <Row type="flex" justify="start" align="middle">
            <Col span={8}>
              <span>Business Phone Number</span>
            </Col>
            <Col span={16}>
              <div className="d-flex">
                <Select
                  style={{ width: '25%' }}
                  defaultValue={countryCode}
                  onChange={onCountryCodeChange}
                >
                  {COUNTRY_CODES.map((item) => (
                    <Option key={item.ID} value={item.PHONE_CODE}>
                      {item.PHONE_CODE}
                    </Option>
                  ))}
                </Select>
                <div style={{ width: '75%' }}>
                  <NumberFormat
                    className="InputnumFormate"
                    value={businessPhoneNumber}
                    format={phoneFormate}
                    mask="_"
                    allowEmptyFormatting
                    onChange={onPhoneNumberChange}
                  />
                  <SpError>
                    {simpleValidator.current.message('Phone', businessPhoneNumber, 'required|phoneLength')}
                  </SpError>
                </div>
              </div>
            </Col>
          </Row>
        )}
        <Row type="flex" justify="start" align="middle">
          <Col span={8}>
            <span>Street Address</span>
          </Col>
          <Col span={16}>
            <Input
              placeholder="Street address for business"
              value={streetAddress}
              onBlur={() => setStreetAddress(streetAddress && streetAddress.trim())}
              onChange={e => setStreetAddress(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('Street Address', streetAddress, 'required')}
            </SpError>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={8}>
            <span>{zipTag}</span>
          </Col>
          <Col span={16}>
            <Input
              placeholder={zipTag}
              value={zipCode}
              onBlur={() => setZipCode(zipCode && zipCode.trim())}
              onChange={e => setZipCode(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('Area Code', zipCode, 'required|postalcode')}
            </SpError>
          </Col>
        </Row>
        <Row type="flex" justify="start" align="middle">
          <Col span={8}>
            <span>City</span>
          </Col>
          <Col span={16}>
            <Input
              placeholder="City"
              value={city}
              onBlur={() => setCity(city && city.trim())}
              onChange={e => setCity(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('City', city, 'required')}
            </SpError>
          </Col>
        </Row>
        <Row type="flex" justify="start" align="middle">
          <Col span={8}>
            <span>State</span>
          </Col>
          <Col span={16}>
            <Select
              placeholder="Select State"
              showSearch
              optionFilterProp="children"
              className="w-100"
              value={state}
              onChange={value => setState(value)}
            >
              {
                statesInCountry.map(s => (
                  <Option
                    key={s.id}
                    value={s.id}
                    className="text-capitalize"
                  >
                    {s.name}
                  </Option>
                ))
              }
            </Select>
            <SpError>
              {simpleValidator.current.message('State', state, 'required')}
            </SpError>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={8}>
            <span>Country</span>
          </Col>
          <Col span={16}>
            <Select value={country} style={{ width: '100%' }} disabled>
              <Option key={country} value={country}>{country}</Option>
            </Select>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={8}>
            <span>Statement Descriptor</span>
          </Col>
          <Col span={16}>
            <Input
              placeholder="Statement Descriptor"
              value={statementDescriptor}
              onBlur={() => setStatementDescriptor(statementDescriptor && statementDescriptor.trim())}
              onChange={e => setStatementDescriptor(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('Statement Descriptor', statementDescriptor, 'required|descriptor')}
            </SpError>
          </Col>

          <Col span={24}>
            <SpTextMute>
              This business name show up on your customer’s statements.
              Choose something they will recognize to help prevent disputes.
            </SpTextMute>
          </Col>
        </Row>

        {
          !isIndia && (
            <>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>Is Business Tax Exempted Organisation</span>
                </Col>
                <Col span={16}>
                  <Select
                    placeholder="Is Business Tax Exempted Organisation"
                    optionFilterProp="children"
                    className="w-100"
                    showSearch
                    value={isTaxExemptOrganisation}
                    onChange={(value) => {
                      setIsTaxExemptOrganisation(value);
                    }}
                  >
                    <Option key={1} value>Yes</Option>
                    <Option key={2} value={false}>No</Option>
                  </Select>
                </Col>
                <Col>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
              </Row>
            </>
          )
        }

        {
          isIndia && (
            <>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>Account Type</span>
                </Col>
                <Col span={9}>
                  <Radio.Group onChange={onAccountChange} value={accountType}>
                    <Radio value="PAYMENT_GATEWAY">Online Payment Gateway</Radio>
                    <Radio value="POS">POS</Radio>
                  </Radio.Group>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>Estimated Annual Turnover</span>
                </Col>
                <Col span={16}>
                  <Input
                    value={annualTurnOver}
                    placeholder="Estimated Annual Turnover"
                    onChange={(e) => {
                      const regex = /^\d*\.?\d*$/;
                      const { value } = e.currentTarget;
                      if (regex.test(value) || value === '') {
                        setAnnualTurnOver(e.currentTarget.value);
                      } else if (!regex.test(value)) {
                        setAnnualTurnOver(0.00);
                      }
                    }}
                    onKeyPress={e => {
                      const keyCode = e.charCode || e.which;
                      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                        e.preventDefault();
                      }
                    }}
                    onBlur={e => {
                      if (e.currentTarget.value) {
                        const value = formatAmount(e.currentTarget.value, currencyType);
                        setAnnualTurnOver(value);
                      }
                    }}
                  />
                </Col>
                <Col>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>Estimated Annual Card Volume</span>
                </Col>
                <Col span={16}>
                  <Input
                    value={annualCardVolume}
                    placeholder="Estimated Annual Card Volume"
                    onChange={(e) => {
                      const regex = /^\d*\.?\d*$/;
                      const { value } = e.currentTarget;
                      if (regex.test(value) || value === '') {
                        setAnnualCardVolume(e.currentTarget.value);
                      } else if (!regex.test(value)) {
                        setAnnualCardVolume(0.00);
                      }
                    }}
                    onKeyPress={e => {
                      const keyCode = e.charCode || e.which;
                      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                        e.preventDefault();
                      }
                    }}
                    onBlur={e => {
                      if (e.currentTarget.value) {
                        const value = formatAmount(e.currentTarget.value, currencyType);
                        setAnnualCardVolume(value);
                      }
                    }}
                  />
                </Col>
                <Col>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>Estimated Annual UPI Volume</span>
                </Col>
                <Col span={16}>
                  <Input
                    value={annualUpiVolume}
                    placeholder="Estimated Annual UPI Volume"
                    onChange={(e) => {
                      const regex = /^\d*\.?\d*$/;
                      const { value } = e.currentTarget;
                      if (regex.test(value) || value === '') {
                        setAnnualUpiVolume(e.currentTarget.value);
                      } else if (!regex.test(value)) {
                        setAnnualUpiVolume(0.00);
                      }
                    }}
                    onKeyPress={e => {
                      const keyCode = e.charCode || e.which;
                      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                        e.preventDefault();
                      }
                    }}
                    onBlur={e => {
                      if (e.currentTarget.value) {
                        const value = formatAmount(e.currentTarget.value, currencyType);
                        setAnnualUpiVolume(value);
                      }
                    }}
                  />
                </Col>
                <Col>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
              </Row>
              {accountType === 'POS' && (
                <>
                  <Row type="flex" justify="start" align="middle">
                    <Col span={8}>
                      <span>Store Front Picture</span>
                    </Col>
                    <Col span={16}>
                      <KYCFileUpload
                        name="FRONT"
                        endPoint={API_END_POINTS.UPLOAD_STORE_FRONT}
                        url={frontUrl}
                        setUrl={value => setFrontUrl(value)}
                        type="Business"
                      />
                      <SpError>
                        {simpleValidator.current.message('Store Front Url', frontUrl, 'required')}
                      </SpError>
                    </Col>
                    <Col span={8} className="ml-4">
                      <SpTextMute>
                        Upload an Image with Store front details of business.  Self attested mandatory.
                      </SpTextMute>
                    </Col>
                  </Row>
                  <Row type="flex" justify="start" align="middle">
                    <Col span={8}>
                      <span>Store Inside Picture</span>
                    </Col>
                    <Col span={16}>
                      <KYCFileUpload
                        name="INSIDE"
                        endPoint={API_END_POINTS.UPLOAD_STORE_INSIDE}
                        url={insideUrl}
                        setUrl={value => setInsideUrl(value)}
                        type="Business"
                      />
                      <SpError>
                        {simpleValidator.current.message('Store Inside Url', insideUrl, 'required')}
                      </SpError>
                    </Col>
                    <Col span={8} className="ml-4">
                      <SpTextMute>
                        Upload an Image with Store inside details of business. Self attested mandatory.
                      </SpTextMute>
                    </Col>
                  </Row>
                </>
              )}
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>Business Registration Proof</span>
                </Col>
                <Col span={8}>
                  <KYCFileUpload
                    name="Registration"
                    endPoint={API_END_POINTS.UPLOAD_REGISTRATION}
                    url={registrationProofUrl}
                    setUrl={value => setRegistrationProofUrl(value)}
                    type="Business"
                  />
                  <SpError>
                    {simpleValidator.current.message('Registration Proof Url', registrationProofUrl, 'required')}
                  </SpError>
                </Col>
                <Col span={6} className="ml-2">
                  {
                    businessType === 'PROPRIETORSHIP' ? (
                      <SpTextMute>
                        GST Certificate / Shop Establishment Act Certificate / Registration Certificate
                      </SpTextMute>
                    ) : (
                      <SpTextMute>
                        {
                          BUSINESS_VALUES.includes(businessType)
                            ? 'Upload an Image or pdf of Certification of Incorporation'
                            : 'Upload an Image or pdf of Partnership Deed'
                        }
                      </SpTextMute>
                    )
                  }
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>Business PAN Proof</span>
                </Col>
                <Col span={8}>
                  <KYCFileUpload
                    name="PAN"
                    endPoint={API_END_POINTS.UPLOAD_PAN}
                    url={panUrl}
                    setUrl={value => setPanUrl(value)}
                    type="Business"
                  />
                  <SpError>
                    {simpleValidator.current.message('pan Url', panUrl, 'required',
                      { messages: { required: 'The PAN proof url field is required' } })}
                  </SpError>
                </Col>
                <Col span={6} className="ml-2">
                  <SpTextMute>
                    Upload an Image or pdf with PAN details of business. Self attested mandatory.
                  </SpTextMute>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>Current Address Proof</span>
                </Col>
                <Col span={8}>
                  <KYCFileUpload
                    name="Address"
                    endPoint={API_END_POINTS.UPLOAD_BUSINESS_ADDRESS}
                    url={businessAddressUrl}
                    keyType="BUSINESS_CURRENT_ADDRESS_PROOF"
                    setUrl={value => setBusinessAddressUrl(value)}
                    type="Business"
                  />
                  <SpError>
                    {simpleValidator.current.message('address Url', businessAddressUrl, 'required',
                      { messages: { required: 'The Address proof url field is required' } })}
                  </SpError>
                </Col>
                <Col span={6} className="ml-2">
                  {
                    businessType === 'PROPRIETORSHIP' ? (
                      <SpTextMute>
                        Address Proof:
                        Any Utility Bill (Electricity / Telephone / Water Bill / Gas bill / Municipal Tax (not more than 3 months old)
                        or Insurance policy or Aadhar card). Self attested mandatory.
                      </SpTextMute>
                    ) : businessType === 'LIMITED_LIABILITY_PARTNERSHIP' ? (
                      <SpTextMute>
                        Current address proof of the partnership firm (e.g Utility bills not more than 3 months old). Self attested mandatory.
                      </SpTextMute>
                    ) : (
                      <SpTextMute>
                        Company current Address proof (e.g Utility bills not more than 3 months old). Self attested mandatory.
                      </SpTextMute>
                    )
                  }
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>Board Resolution</span>
                </Col>
                <Col span={8}>
                  <KYCFileUpload
                    name="Boardresolution"
                    endPoint={API_END_POINTS.UPLOAD_BOARD_RESOLUTION}
                    url={boardResolutionUrl}
                    keyType="BUSINESS_BOARD_RESOLUTION_PROOF"
                    setUrl={value => setBoardResolutionUrl(value)}
                    type="Business"
                  />
                  <SpError>
                    {simpleValidator.current.message('board resolution', boardResolutionUrl, 'required',
                      { messages: { required: 'The board resolution url field is required' } })}
                  </SpError>
                </Col>
                <Col span={6} className="ml-2">
                  {
                    businessType === 'PROPRIETORSHIP' ? (
                      <SpTextMute>
                        Bank statement of last 12 months or front copy of bank statement if the account is new.
                      </SpTextMute>
                    ) : businessType === 'LIMITED_LIABILITY_PARTNERSHIP' ? (
                      <SpTextMute>
                        Board Resolution (should be signed by atleast two partners. Should not be self-attested).
                      </SpTextMute>
                    ) : businessType === 'NONPROFIT_ORGANIZATION' ? (
                      <SpTextMute>
                        Board Resolution (should be signed by atleast two trustees. Should not be self-attested).
                      </SpTextMute>
                    ) : (
                      <SpTextMute>
                        Board Resolution (should be signed by atleast two directors or Company Secretary. Should not be self-attested).
                      </SpTextMute>
                    )
                  }
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={8}>
                  <span>GST Certificate</span>
                </Col>
                <Col span={8}>
                  <KYCFileUpload
                    name="GSTCertificate"
                    endPoint={API_END_POINTS.UPLOAD_GST_CERTIFICATE}
                    url={gstProofUrl}
                    keyType="BUSINESS_GST_CERTIFICATE"
                    setUrl={value => setGstProofUrl(value)}
                    type="Business"
                  />
                  <SpError>
                    {simpleValidator.current.message('gst Url', gstProofUrl, 'required',
                      { messages: { required: 'The GST certificate url field is required' } })}
                  </SpError>
                </Col>
                <Col span={6} className="ml-2">
                  <SpTextMute>
                    GST Certificate. Self attested mandatory.
                  </SpTextMute>
                </Col>
              </Row>
              {
                businessType === 'NONPROFIT_ORGANIZATION' && (
                  <Row type="flex" justify="start" align="middle">
                    <Col span={8}>
                      <span>80G and 12A Certficate</span>
                    </Col>
                    <Col span={8}>
                      <KYCFileUpload
                        name="80GCertificate"
                        endPoint={API_END_POINTS.UPLOAD_EIGHTY_TWELVE}
                        url={eightyTwelveUrl}
                        keyType="BUSINESS_EIGHTY_G_AND_TWELVE_A_CERTIFICATE"
                        setUrl={value => setEightyTwelveUrl(value)}
                        type="Business"
                      />
                      <SpError>
                        {simpleValidator.current.message('80g and 12a Url', eightyTwelveUrl, 'required',
                          { messages: { required: 'The 80G and 12A certificate url field is required' } })}
                      </SpError>
                    </Col>
                    <Col span={6} className="ml-2">
                      <SpTextMute>
                        80G certificate and 12A Certficate. Self attested mandatory.
                      </SpTextMute>
                    </Col>
                  </Row>
                )
              }
            </>
          )
        }
      </SpForm>
    </>
  );
};

// $FlowFixMe
export default forwardRef(BusinessDetails);
